import { QueryClientProvider as TanStackQueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { type FC, type PropsWithChildren } from 'react'
import { queryClient } from './queryClient'

const isDevelopment = import.meta.env.MODE === 'development' || import.meta.env.DEV
const isPlaywrightTest = import.meta.env.PUBLIC_PLAYWRIGHT_TEST === 'true'
const shouldShowDevTools = isDevelopment && !isPlaywrightTest

export const QueryClientProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <TanStackQueryClientProvider client={queryClient}>
      {children}
      {shouldShowDevTools && <ReactQueryDevtools initialIsOpen={false} />}
    </TanStackQueryClientProvider>
  )
}
